module.exports = __webpack_public_path__ + "static/img/0507ny_tit5.e03483b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/picture/nxzw/0507ny_tit5.png
// module id = tKFC
// module chunks = 0